module.exports = __webpack_public_path__ + "img/sand-rock-medium-09.d5949f2f.png";